import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "./context/UserContext"


const ProtectedRoutes = ({children}) => {
    const {isAuth} = useAuth()
    const location = useLocation()

    if (!isAuth) {
        return (
            <Navigate to='/auth/login' state={{from: location}}/>
        )
    }
    return children
}

export default ProtectedRoutes